import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const AuthRoute = () => {
  const { user, accessToken, loading } = useSelector(
    (state) => state.merchant
  );

  // ⏳ WAIT until restoreSession finishes
  if (loading) {
    return null; // or spinner
  }

  if (!user || !accessToken) {
    return <Navigate to="/merchant-login" replace />;
  }

  return <Outlet />;
};

export default AuthRoute;
